import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-content-between w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Administrare"),
    /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Decontări")
  ])
], -1)
const _hoisted_2 = { class: "app-inner-container" }

import { DoctorPayoutInfo } from '@/interfaces/DoctorPayoutInfo';
import DoctorPayoutList from '@/components/DoctorPayoutList.vue';
import { onMounted, ref } from 'vue';
import PayoutService from '@/services/PayoutService';
import Card from 'primevue/card';

// Vars definitions

export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutListView',
  setup(__props) {

const doctors = ref<DoctorPayoutInfo[]>();

// Functions definitions
const fetchDoctors = async () => {
  try {
    doctors.value =
      (await PayoutService.fetchPayoutInfos()) as DoctorPayoutInfo[];
  } catch (error) {
    console.error(error as string);
  }
};

// Component actions
onMounted(fetchDoctors);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Toast),
        _createVNode(DoctorPayoutList, { doctors: doctors.value }, null, 8, ["doctors"])
      ])
    ]),
    _: 1
  }))
}
}

})